import VueI18n from "vue-i18n";
import Vue from "vue";
import enLang from "./locales/en.json";
import jaLang from "./locales/ja.json";
import koLang from "./locales/ko.json";
import viLang from "./locales/vi.json";
import cnLang from "./locales/cn.json";
Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "en",
  messages: {
    en: enLang,
    ja: jaLang,
    ko: koLang,
    vi: viLang,
    cn: cnLang
  },
  fallbackLocale: "en",
});

export default i18n;
